import { jsxs as l, jsx as t } from "react/jsx-runtime";

import { useMemo as e } from "react";

import o from "../CalendarSlot/index.js";

const r = ({daySlots: r, onAvailableSlotClick: a}) => {
    const i = e((() => r.slice(0, 2)), [ r ]), n = r.length - i.length;
    return l("div", {
        className: "relative mt-1.5 flex h-full w-full flex-col gap-1.5",
        children: [ i.map((l => t(o, {
            slot: l,
            shouldHideTitle: !0,
            staticPosition: !0,
            onAvailableSlotClick: a
        }, l.id))), !!n && l("button", {
            type: "button",
            className: "typography-small flex h-6 w-full items-center rounded bg-neutral-200 pl-3 pr-1.5 font-semibold leading-4 text-neutral-800 transition-transform hover:z-[10000] hover:scale-105",
            onClick: a,
            children: [ "+", n, " more" ]
        }) ]
    });
};

export { r as default };
//# sourceMappingURL=index.js.map
